export const contactsData = {
    email: 'balurajadurai.webdeveloper@gmail.com',
    phone: '+91 8056921890',
    address: 'Coimbatore, Tamil Nadu',

    sheetAPI: 'https://sheetdb.io/api/v1/xfmm7aayedvao'
}
